export default __webpack_public_path__ + "static/media/profile-placeholder-p.e8629e8c.png";